import { Box } from "@mui/material";

const Wrapper = (props) => {

    const { children } = props;

    return (
        <Box sx={{ display: 'flex', padding: "0 16px" }}>
            {children}
        </Box>
    )
}
export default Wrapper;